import { render, staticRenderFns } from "./ListTournamentsRating.vue?vue&type=template&id=327329df&scoped=true"
import script from "./ListTournamentsRating.vue?vue&type=script&lang=js"
export * from "./ListTournamentsRating.vue?vue&type=script&lang=js"
import style0 from "./ListTournamentsRating.vue?vue&type=style&index=0&id=327329df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327329df",
  null
  
)

export default component.exports